export default __webpack_public_path__ + "static/media/cellarqrbg.77c535fc.png";